import {
	MantineProvider as MantineProviderBase,
	Modal,
	Switch,
	type VariantColorsResolver,
	createTheme,
	defaultVariantColorsResolver,
} from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@src/components/modals/modals";
import { useAppColorScheme } from "./color-scheme-store";

const variantColorResolver: VariantColorsResolver = (input) => {
	const defaultResolvedColors = defaultVariantColorsResolver(input);

	if (input.variant === "cta") {
		return {
			background: "var(--ui-color-brand-primary)",
			hover: "var(--ui-color-brand-primary-hover)",
			color: "var(--ui-color-text-inverse)",
			border: "none",
		};
	}

	return defaultResolvedColors;
};

const theme = createTheme({
	fontFamily:
		"Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
	headings: {
		fontFamily:
			"Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
	},
	variantColorResolver,
	components: {
		Modal: Modal.extend({
			defaultProps: {
				overlayProps: {
					backgroundOpacity: 0.55,
					blur: 8,
				},
				radius: "md",
			},
			classNames: {
				content: "bg-surface-default text-text-primary",
			},
		}),
		Switch: Switch.extend({
			defaultProps: {
				color: "var(--ui-color-brand-primary)",
			},
		}),
	},
});

export function MantineProvider({
	children,
}: {
	children: React.ReactNode;
}) {
	const { colorScheme } = useAppColorScheme();

	return (
		<MantineProviderBase theme={theme} forceColorScheme={colorScheme}>
			<Notifications zIndex={9999} />
			<ModalsProvider>{children}</ModalsProvider>
		</MantineProviderBase>
	);
}
